import { ordersApi } from "../store/api/ordersApi";
import { runMutation, runQuery } from "../store/api/runtime";

type OrderPayload = Record<string, unknown>;

export const createOrder = async (orderData: OrderPayload): Promise<unknown> =>
  runMutation(ordersApi.endpoints.createOrder.initiate, orderData);

export const getUserOrders = async (userId: string): Promise<unknown> =>
  runQuery(ordersApi.endpoints.getUserOrders.initiate, userId);

export const getSellerOrders = async (userId: string): Promise<unknown> =>
  runQuery(ordersApi.endpoints.getSellerOrders.initiate, userId);

export const getOrderById = async (orderId: string): Promise<unknown> =>
  runQuery(ordersApi.endpoints.getOrderById.initiate, orderId);

export const updateOrderStatus = async (
  orderId: string,
  status: string,
  trackingNumber: string | null = null,
): Promise<unknown> => runMutation(ordersApi.endpoints.updateOrderStatus.initiate, { orderId, status, trackingNumber });
